import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Span, Toggle, Text } from "@netapp/bxp-design-system-react";
import _ from "lodash";
import { allMenus as i18nNamespace } from "../../../../../../i18n/namespace";
import userMenuStyles from "../../../headerMenus/UserMenu.module.scss";
import RoleElevationChangeConfirmationModal from "./RoleElevationChangeConfirmationModal";
import { isOrgInSafeMode } from "../../../../../identity-access-management/utils";

const SafeModeUserRoleElevateToggle = () => {
    const { selectedOrg, isUserElevated } = useSelector(state => ({
        selectedOrg: state.tenancy.selectedOrg,
        isUserElevated: state.tenancy?.user?.isUserElevated,
    }));
    const [showRoleElevationChangeConfirmation, setShowRoleElevationChangeConfirmation] = useState(false);
    const [isToggleActive, setIsToggleActive] = useState(isUserElevated);
    const orgInSafeMode = selectedOrg ? isOrgInSafeMode(selectedOrg["tags"]) : false;
    const { t } = useTranslation(i18nNamespace);
    
    const OnConfirmationOk = () => {
        setIsToggleActive(!isToggleActive);
        setShowRoleElevationChangeConfirmation(false);
        setTimeout(() => window.location.reload(), 1000);
    }

    return (
        <>
            {orgInSafeMode && <div className={userMenuStyles["detail"]}>
                {showRoleElevationChangeConfirmation && <RoleElevationChangeConfirmationModal isUserRequestingElevation={!isUserElevated} OnConfirmationCancel={() => setShowRoleElevationChangeConfirmation(false)}
                    OnConfirmationOk={() => OnConfirmationOk()} />}
                <div className={userMenuStyles["details-label"]}>
                    <div>{t('read_only_status')}</div>
                    <Span style={{ display: "flex", marginBottom: 5 }}>
                        <Toggle style={{ paddingRight: 6 }} value={isToggleActive} toggle={() => setShowRoleElevationChangeConfirmation(true)} />
                        <Text>{t('elevated')}</Text>
                    </Span>
                </div>
            </div>}
        </>
    );
}
export default SafeModeUserRoleElevateToggle;